@if (isRmbOnly && isNotAdded && !isMedBillCarryFwSw) {
<p [innerHTML]="'START2_STATIC_TEXT_11' | globalTranslate"></p>
} @if (isMedBillCarryFwSw) {
<p [innerHTML]="'START2_STATIC_TEXT_11_NEW' | globalTranslate"></p>
}
<h1 class="person-label">{{ selectedIndividual | fullname }}</h1>
@if (!isMedBillCarryFwSw) {
<nh-form
  [topLevelName]="'me'"
  [individuals]="checkForDropdown ? finalListAll : individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  class="labe-section"
  topLevelQuestion="{{ 'MEDICAL_BILLS_STATIC_TEXT1' | globalTranslate }}"
  individualQuestion="{{ this.individualQuestion | globalTranslate }}"
  [individualQuestionAria]="this.individualQuestionAria"
  (validate)="onValidate($event)"
>
  <div [formGroup]="getControl('data')">
    @if ((getValue('extras.topLevelAnswer') === 'YES') && (this.showKbQuestion))
    {
    <nh-field
      id="me_kbMedicalBillsSw"
      label="{{ kbReferralQuestion }}"
      class="label-section"
    >
      <nh-popover
        style="padding-left: 3px"
        content="{{ 'MEDICAL_BILLS_TOOLTIP' | globalTranslate }}"
      ></nh-popover>
      <select
        nhTranslate
        name="kbMedicalBillsSw"
        formControlName="kbMedicalBillsSw"
        aria-label="kbMedicalBillsSw"
        [items]="tableCodeValue('YESNO', 'data.kbMedicalBillsSw')"
        (change)="setValidations($event)"
      ></select>
    </nh-field>
    }
  </div>
  @if ((isY('data.kbMedicalBillsSw')) || (!this.showKbQuestion)) {
  <div [formGroup]="getControl('data')">
    <h2 class="section-header">
      {{ "MEDICAL_BILLS_STATIC_TEXT2" | globalTranslate }}
    </h2>
    <hr />
    <nh-field
      id="me_medicalBillType"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT3_1' | globalTranslate }} {{
        this.selectedIndividual | fullname
      }} {{ 'MEDICAL_BILLS_STATIC_TEXT4' | globalTranslate }}"
      class="label-section"
    >
      <div class="hint">
        {{ "IF" | globalTranslate }} {{ this.selectedIndividual | fullname }}
        <span
          class="hint"
          [innerHTML]="this.medicalBillsHint | globalTranslate"
          >{{ this.medicalBillsHint | globalTranslate }}</span
        >
      </div>
      <select
        class="zoom-friendly-select"
        nhTranslate
        name="medicalBillType"
        formControlName="medicalBillType"
        [attr.aria-label]="
          ('MEDICAL_BILLS_STATIC_TEXT3_1' | globalTranslate) +
          ' ' +
          (this.selectedIndividual | fullname) +
          ' ' +
          ('MEDICAL_BILLS_STATIC_TEXT4' | globalTranslate)
        "
        [items]="tableCodeValue('MEDNEEDYEXPENSES', 'data.medicalBillType')"
        (change)="showHide()"
        required
      ></select>
    </nh-field>
    <div class="ps-1 pt-1 hover-red">
      <a
        class="btn btn-link hover-red"
        style="padding-left: 0"
        (click)="showModal()"
        tabindex="0"
      >
        <span class="pe-2">{{
          "MEDICAL_BILLS_STATIC_TEXT5" | globalTranslate
        }}</span>
        <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
      </a>
    </div>
    <nh-field
      id="me_careReceivingIndvNumber"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT6' | globalTranslate }} {{
        medicalBillType.value
          ? (medicalBillType.value.value | globalTranslate)
          : ''
      }}{{ 'MEDICAL_BILLS_STATIC_TEXT7' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="careReceivingIndvNumber"
        [attr.aria-label]="
          ('MEDICAL_BILLS_STATIC_TEXT6' | globalTranslate) +
          ' ' +
          (medicalBillType.value
            ? (medicalBillType.value.value | globalTranslate)
            : '') +
          ' ' +
          ('MEDICAL_BILLS_STATIC_TEXT7' | globalTranslate)
        "
        [items]="indi"
        bindValue="identifier"
        bindLabel="name.fullName"
        formControlName="careReceivingIndvNumber"
        (change)="setIndiv()"
        required
      ></select>
    </nh-field>
    @if (isEnabled('data.personOutOfHouseholdName')) {
    <nh-field
      id="me_personOutOfHouseholdName"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT8' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        class="form-control"
        name="personOutOfHouseholdName"
        formControlName="personOutOfHouseholdName"
        [attr.aria-label]="'MEDICAL_BILLS_STATIC_TEXT8' | globalTranslate"
        required
      />
    </nh-field>
    } @if (isEnabled('data.relationPersonOutsideHH')) {
    <nh-field
      id="me_relationPersonOutsideHH"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT9' | globalTranslate }} {{
        personOutOfHouseholdName.value
      }} {{ 'MEDICAL_BILLS_STATIC_TEXT10' | globalTranslate }} {{
        head | fullname
      }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="relationPersonOutsideHH"
        formControlName="relationPersonOutsideHH"
        [attr.aria-label]="
          ('MEDICAL_BILLS_STATIC_TEXT9' | globalTranslate) +
          ' ' +
          personOutOfHouseholdName.value +
          ' ' +
          ('MEDICAL_BILLS_STATIC_TEXT10' | globalTranslate) +
          ' ' +
          (head | fullname)
        "
        [items]="
          tableCodeValue(
            'RELATIONSHIPTOINDIVIDUAL',
            'data.relationPersonOutsideHH'
          )
        "
        required
      ></select>
    </nh-field>
    }
    <nh-field
      id="me_billPayingFrequencycd"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT11' | globalTranslate }} {{
        medicalBillType.value
          ? (medicalBillType.value.value | globalTranslate)
          : ''
      }}{{ 'MEDICAL_BILLS_STATIC_TEXT12' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="billPayingFrequencycd"
        formControlName="billPayingFrequencycd"
        [attr.aria-label]="
          ('MEDICAL_BILLS_STATIC_TEXT11' | globalTranslate) +
          ' ' +
          (medicalBillType.value
            ? (medicalBillType.value.value | globalTranslate)
            : '') +
          ' ' +
          ('MEDICAL_BILLS_STATIC_TEXT12' | globalTranslate)
        "
        [items]="
          tableCodeValue('INCEXPPAYFREQUENCY', 'data.billPayingFrequencycd')
        "
        required
      ></select>
    </nh-field>
    <nh-field
      id="me_careReceiveDate"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT13_1' | globalTranslate }} {{
        this.otherSelectedIndividual
      }}{{ personOutOfHouseholdName.value }} {{
        'MEDICAL_BILLS_STATIC_TEXT14' | globalTranslate
      }}"
      class="label-section"
    >
      <nh-datepicker>
        <input
          type="text"
          name="careReceiveDate"
          class="form-control"
          formControlName="careReceiveDate"
          [attr.aria-label]="
            ('MEDICAL_BILLS_STATIC_TEXT13_1' | globalTranslate) +
            ' ' +
            this.otherSelectedIndividual +
            ' ' +
            ('MEDICAL_BILLS_STATIC_TEXT14' | globalTranslate)
          "
          [maxDate]="today"
          bsDatepicker
          (bsValueChange)="toggleAmountFields($event)"
          nh
          (change)="toggleAmountFields($event)"
          required
        />
      </nh-datepicker>
    </nh-field>
    @if (isEnabled('data.medicalBillUnpaidAmt')) {
    <nh-field
      id="me_medicalBillUnpaidAmt"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT15_1' | globalTranslate }} {{
        this.otherSelectedIndividual
      }}{{ 'APOSTROPHE_S' | globalTranslate }} {{
        medicalBillType.value
          ? (medicalBillType.value.value | globalTranslate)
          : ''
      }} {{ 'MEDICAL_BILLS_STATIC_TEXT16' | globalTranslate }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          [attr.aria-label]="
            ('MEDICAL_BILLS_STATIC_TEXT15_1' | globalTranslate) +
            ' ' +
            this.otherSelectedIndividual +
            ('APOSTROPHE_S' | globalTranslate) +
            ' ' +
            (medicalBillType.value
              ? (medicalBillType.value.value | globalTranslate)
              : '') +
            ' ' +
            ('MEDICAL_BILLS_STATIC_TEXT16' | globalTranslate)
          "
          separatorLimit="999999999"
          formControlName="medicalBillUnpaidAmt"
          class="form-control"
          required
        />
      </nh-input-group>
    </nh-field>
    } @if (isEnabled('data.medicalBillOweAmt') && dateMoreThan3Months) {
    <nh-field
      id="me_medicalBillOweAmt"
      [mandatory]="true"
      [attr.aria-required]="true"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT17' | globalTranslate }} {{
        medicalBillType.value
          ? (medicalBillType.value.value | globalTranslate)
          : ''
      }} {{ 'MEDICAL_BILLS_STATIC_TEXT18_1' | globalTranslate }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          [attr.aria-label]="
            ('MEDICAL_BILLS_STATIC_TEXT17' | globalTranslate) +
            ' ' +
            (medicalBillType.value
              ? (medicalBillType.value.value | globalTranslate)
              : '') +
            ' ' +
            ('MEDICAL_BILLS_STATIC_TEXT18_1' | globalTranslate)
          "
          separatorLimit="999999999"
          formControlName="medicalBillOweAmt"
          class="form-control"
        />
      </nh-input-group>
    </nh-field>
    } @if (isEnabled('data.medicalBillOweAmt') && !dateMoreThan3Months) {
    <nh-field
      id="me_medicalBillOweAmt"
      [mandatory]="true"
      [attr.aria-required]="true"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT17_1' | globalTranslate }} {{
        medicalBillType.value
          ? (medicalBillType.value.value | globalTranslate)
          : ''
      }} {{ 'MEDICAL_BILLS_STATIC_TEXT22_1' | globalTranslate }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          [attr.aria-label]="
            ('MEDICAL_BILLS_STATIC_TEXT17_1' | globalTranslate) +
            ' ' +
            (medicalBillType.value
              ? (medicalBillType.value.value | globalTranslate)
              : '') +
            ' ' +
            ('MEDICAL_BILLS_STATIC_TEXT22_1' | globalTranslate)
          "
          separatorLimit="999999999"
          formControlName="medicalBillOweAmt"
          class="form-control"
          required
        />
      </nh-input-group>
    </nh-field>
    } @if (isEnabled('data.milesPerAppointment')) {
    <nh-field
      id="me_milesPerAppointment"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT19' | globalTranslate }} {{
        otherSelectedIndividual !== ''
          ? otherSelectedIndividual
          : personOutOfHouseholdName.value
      }} {{ 'MEDICAL_BILLS_STATIC_TEXT20' | globalTranslate }}"
      class="label-section"
      [col9]="true"
    >
      <nh-popover
        class="ps-1"
        content="{{ 'MEDICAL_BILLS_STATIC_TEXT21' | globalTranslate }}"
      ></nh-popover>
      <input
        type="text"
        class="form-control"
        formControlName="milesPerAppointment"
        [attr.aria-label]="
          ('MEDICAL_BILLS_STATIC_TEXT19' | globalTranslate) +
          ' ' +
          (otherSelectedIndividual !== ''
            ? otherSelectedIndividual
            : personOutOfHouseholdName.value) +
          ' ' +
          ('MEDICAL_BILLS_STATIC_TEXT20' | globalTranslate)
        "
      />
    </nh-field>
    }
  </div>
  }
</nh-form>
}

<!--  when you click edit on existing bill these are set of question visible-->

@if (isMedBillCarryFwSw && isRmbOnly) {
<nh-form
  [topLevelName]="'me'"
  [individuals]="checkForDropdown ? finalListAll : individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  class="labe-section"
  topLevelQuestion="{{ 'MEDICAL_BILLS_STATIC_TEXT1' | globalTranslate }}"
  individualQuestion="{{ this.individualQuestion }}"
  (validate)="onValidate($event)"
>
  @if ((isY('data.kbMedicalBillsSw')) || (!this.showKbQuestion)) {
  <div [formGroup]="getControl('data')">
    <h2 class="section-header">
      {{ "MEDICAL_BILLS_STATIC_TEXT2" | globalTranslate }}
    </h2>
    <hr />
    <nh-field
      id="me_medicalBillType"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT3' | globalTranslate }} {{
        this.selectedIndividual | fullname
      }} {{ 'MEDICAL_BILLS_STATIC_TEXT4' | globalTranslate }}"
      class="label-section"
    >
      <div class="hint">
        {{ "IF" | globalTranslate }} {{ this.selectedIndividual | fullname }}
        <span
          class="hint"
          [innerHTML]="this.medicalBillsHint | globalTranslate"
          >{{ this.medicalBillsHint | globalTranslate }}</span
        >
      </div>
      <select
        class="zoom-friendly-select"
        nhTranslate
        name="medicalBillType"
        formControlName="medicalBillType"
        [attr.aria-label]="
          ('MEDICAL_BILLS_STATIC_TEXT3' | globalTranslate) +
          ' ' +
          (this.selectedIndividual | fullname) +
          ' ' +
          ('MEDICAL_BILLS_STATIC_TEXT4' | globalTranslate)
        "
        [items]="tableCodeValue('MEDNEEDYEXPENSES', 'data.medicalBillType')"
        (change)="showHide()"
        [attr.disabled]="true"
      ></select>
    </nh-field>
    <div class="ps-1 pt-1 hover-red">
      <a
        class="btn btn-link hover-red"
        style="padding-left: 0"
        (click)="showModal()"
        tabindex="0"
      >
        <span class="pe-2">{{
          "MEDICAL_BILLS_STATIC_TEXT5" | globalTranslate
        }}</span>
        <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
      </a>
    </div>
    <nh-field
      id="me_careReceivingIndvNumber"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT6' | globalTranslate }} {{
        medicalBillType.value
          ? (medicalBillType.value.value | globalTranslate)
          : ''
      }}{{ 'MEDICAL_BILLS_STATIC_TEXT7' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="careReceivingIndvNumber"
        [attr.aria-label]="
          ('MEDICAL_BILLS_STATIC_TEXT6' | globalTranslate) +
          ' ' +
          (medicalBillType.value
            ? (medicalBillType.value.value | globalTranslate)
            : '') +
          ' ' +
          ('MEDICAL_BILLS_STATIC_TEXT7' | globalTranslate)
        "
        [items]="indi"
        bindValue="identifier"
        bindLabel="name.fullName"
        formControlName="careReceivingIndvNumber"
        (change)="setIndiv()"
        [attr.disabled]="true"
      ></select>
    </nh-field>
    @if (isEnabled('data.personOutOfHouseholdName')) {
    <nh-field
      id="me_personOutOfHouseholdName"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT8' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        class="form-control"
        name="personOutOfHouseholdName"
        formControlName="personOutOfHouseholdName"
        [attr.disabled]="true"
      />
    </nh-field>
    } @if (isEnabled('data.relationPersonOutsideHH')) {
    <nh-field
      id="me_relationPersonOutsideHH"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT9' | globalTranslate }} {{
        personOutOfHouseholdName.value
      }} {{ 'MEDICAL_BILLS_STATIC_TEXT10' | globalTranslate }} {{
        head | fullname
      }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="relationPersonOutsideHH"
        formControlName="relationPersonOutsideHH"
        [items]="
          tableCodeValue(
            'RELATIONSHIPTOINDIVIDUAL',
            'data.relationPersonOutsideHH'
          )
        "
        [attr.disabled]="true"
      ></select>
    </nh-field>
    }
    <!-- <nh-field id = "me_billPayingFrequencycd"
                          label="{{'MEDICAL_BILLS_STATIC_TEXT11' | globalTranslate }} {{medicalBillType.value? medicalBillType.value.value: ''}}{{'MEDICAL_BILLS_STATIC_TEXT12' | globalTranslate }}"
                          class="label-section">
                          <select nh name="billPayingFrequencycd" formControlName="billPayingFrequencycd" aria-label="billPayingFrequencycd"
                          [items]="tableCodeValue('INCEXPPAYFREQUENCY', 'data.billPayingFrequencycd')" [attr.disabled]="true"></select>
                        </nh-field> -->
    <nh-field
      id="me_careReceiveDate"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT13' | globalTranslate }}"
      class="label-section"
    >
      <nh-datepicker>
        <input
          type="text"
          [attr.disabled]="true"
          name="careReceiveDate"
          class="form-control"
          formControlName="careReceiveDate"
          [maxDate]="today"
          bsDatepicker
          (bsValueChange)="toggleAmountFields($event)"
          nh
          (change)="toggleAmountFields($event)"
        />
      </nh-datepicker>
    </nh-field>
    @if (isEnabled('data.medicalBillUnpaidAmt')) {
    <nh-field
      id="me_medicalBillUnpaidAmt"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT15' | globalTranslate }} {{
        translatedLang === 'en'
          ? languageUpdate
          : medicalBillType.value
          ? (medicalBillType.value.value | globalTranslate)
          : ''
      }} {{
        (translatedLang === 'en' ? 'MEDICAL_BILLS_STATIC_TEXT16_1' : '')
          | globalTranslate
      }} 
    {{
        translatedLang === 'en' && medicalBillType.value
          ? (medicalBillType.value.value | globalTranslate)
          : ''
      }} {{
        (translatedLang === 'en' ? 'MEDICAL_BILLS_STATIC_TEXT16' : '')
          | globalTranslate
      }} {{ translatedLang === 'sp' ? 'de ' + languageUpdate + '?' : '' }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          separatorLimit="999999999"
          [attr.aria-label]="
            ('MEDICAL_BILLS_STATIC_TEXT15' | globalTranslate) +
            ' ' +
            (translatedLang === 'en'
              ? languageUpdate
              : medicalBillType.value
              ? (medicalBillType.value.value | globalTranslate)
              : '') +
            ' ' +
            ((translatedLang === 'en' ? 'MEDICAL_BILLS_STATIC_TEXT16_1' : '')
              | globalTranslate) +
            ' ' +
            (translatedLang === 'en' && medicalBillType.value
              ? (medicalBillType.value.value | globalTranslate)
              : '') +
            ' ' +
            ((translatedLang === 'en' ? 'MEDICAL_BILLS_STATIC_TEXT16' : '')
              | globalTranslate) +
            ' ' +
            (translatedLang === 'sp' ? 'de ' + languageUpdate + '?' : '')
          "
          formControlName="medicalBillUnpaidAmt"
          class="form-control"
          [attr.disabled]="true"
        />
      </nh-input-group>
    </nh-field>
    }
    <!-- <nh-field id = "me_medicalBillOweAmt" [mandatory]="true" [attr.aria-required]="true" *ngIf="isEnabled('data.medicalBillOweAmt') && dateMoreThan3Months"
                            label="{{'MEDICAL_BILLS_STATIC_TEXT17' | globalTranslate }} {{medicalBillType.value? medicalBillType.value.value: ''}} {{ 'MEDICAL_BILLS_STATIC_TEXT18' | globalTranslate }}"
                            class="label-section">
                            <nh-input-group prepend="$">
                              <input nh type="text" placeholder="0.00" mask="separator.2" thousandSeparator="" separatorLimit="999999999" aria-label="medicalBillOweAmt" formControlName="medicalBillOweAmt" class="form-control" [attr.disabled]="true">
                            </nh-input-group>
                          </nh-field> -->
    @if (isEnabled('data.medicalBillOweAmt')) {
    <nh-field
      id="me_medicalBillOweAmt"
      [mandatory]="true"
      [attr.aria-required]="true"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT17' | globalTranslate }} {{
        medicalBillType.value
          ? (medicalBillType.value.value | globalTranslate)
          : ''
      }} {{ 'MEDICAL_BILLS_STATIC_TEXT22' | globalTranslate }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          separatorLimit="999999999"
          [attr.aria-label]="
            ('MEDICAL_BILLS_STATIC_TEXT17' | globalTranslate) +
            ' ' +
            (medicalBillType.value
              ? (medicalBillType.value.value | globalTranslate)
              : '') +
            ' ' +
            ('MEDICAL_BILLS_STATIC_TEXT22' | globalTranslate)
          "
          formControlName="medicalBillOweAmt"
          class="form-control"
          [attr.disabled]="true"
        />
      </nh-input-group>
    </nh-field>
    } @if (isEnabled('data.milesPerAppointment')) {
    <nh-field
      id="me_milesPerAppointment"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT19' | globalTranslate }} {{
        otherSelectedIndividual !== ''
          ? otherSelectedIndividual
          : personOutOfHouseholdName.value
      }} {{ 'MEDICAL_BILLS_STATIC_TEXT20' | globalTranslate }}"
      class="label-section"
    >
      <nh-popover
        class="ps-1"
        content="{{ 'MEDICAL_BILLS_STATIC_TEXT21' | globalTranslate }}"
      ></nh-popover>
      <input
        type="text"
        class="form-control"
        formControlName="milesPerAppointment"
        [attr.disabled]="true"
      />
    </nh-field>
    }
    <nh-field
      id="me_medBillStillOweSw"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT28' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="medBillStillOweSw"
        formControlName="medBillStillOweSw"
        [attr.aria-label]="'MEDICAL_BILLS_STATIC_TEXT28' | globalTranslate"
        [items]="tableCodeValue('YESNO', 'data.medBillStillOweSw')"
        (change)="showOweBill($event)"
      ></select>
    </nh-field>
    @if ((isY('data.medBillStillOweSw'))) {
    <nh-field
      id="medBillStillOweAmt"
      label="{{ 'MEDICAL_BILLS_STATIC_TEXT29' | globalTranslate }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          separatorLimit="999999999"
          [attr.aria-label]="'MEDICAL_BILLS_STATIC_TEXT29' | globalTranslate"
          formControlName="medBillStillOweAmt"
          class="form-control"
          (input)="validateMedBillStillOweAmt($event)"
        />
      </nh-input-group>
      <!-- <div *ngIf="showError === true" class="error-messages position-relative">
                                <span class="form-text invalid-tooltip d-block">
                                  <ng-container> error.errorMessage</ng-container>
                                </span>
                              </div> -->
    </nh-field>
    }
  </div>
  }
</nh-form>
}